import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BannerComponent } from './banner.component';
import {OptionsNgxOwCarouselService} from 'dmmp-services';
import {CarouselModule} from 'ngx-owl-carousel-o';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

@NgModule({
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    CarouselModule,
    CommonModule
  ],
  declarations: [BannerComponent],
  exports: [
    BannerComponent
  ],
  providers: [OptionsNgxOwCarouselService]
})
export class BannerModule { }
